// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

import ProofDetailsActionTypes from './proof-details.types';

/** ***************** ADD BUSINESS PROOF START *********************** */
export const addBusinessProofStart = (proofData: any) => ({
	type: ProofDetailsActionTypes.ADD_BUSINESS_PROOF_START,
	payload: proofData,
});

export const addBusinessProofSuccess = (successValue: any) => ({
	type: ProofDetailsActionTypes.ADD_BUSINESS_PROOF_SUCCESS,
	payload: successValue,
});

export const addBusinessProofFailure = (failureData: any) => ({
	type: ProofDetailsActionTypes.ADD_BUSINESS_PROOF_FAILURE,
	payload: failureData,
});

export const addBusinessProofResponseResetStart = () => ({
	type: ProofDetailsActionTypes.ADD_BUSINESS_PROOF_RESPONSE_RESET,
});

export const addBusinessProofResponseChanged = () => ({
	type: ProofDetailsActionTypes.ADD_BUSINESS_PROOF_RESPONSE_CHANGED,
});
/** ***************** ADD BUSINESS PROOF END *********************** */

/** ***************** BUSINESS PROOF UPDATE START *********************** */
export const updateBusinessProofStart = (updateData: any) => ({
	type: ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_START,
	payload: updateData,
});

export const updateBusinessProofSuccess = (successDate: any) => ({
	type: ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_SUCCESS,
	payload: successDate,
});

export const updateBusinessProofFailure = (failureData: any) => ({
	type: ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_FAILURE,
	payload: failureData,
});

export const updateBusinessProofResponseResetStart = () => ({
	type: ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_RESPONSE_RESET,
});

export const updateBusinessProofResponseChanged = () => ({
	type: ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_RESPONSE_CHANGED,
});
/** ***************** BUSINESS PROOF UPDATE END *********************** */

/** ***************** FETCH BUSINESS PROOF START *********************** */
export const fetchBusinessProofStart = (fetchData: any) => ({
	type: ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_START,
	payload: fetchData,
});

export const fetchBusinessProofSuccess = (successData: any) => ({
	type: ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_SUCCESS,
	payload: successData,
});

export const fetchBusinessProofFailure = (failureData: any) => ({
	type: ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_FAILURE,
	payload: failureData,
});

export const fetchBusinessProofResponseResetStart = () => ({
	type: ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_RESPONSE_RESET,
});

export const fetchBusinessProofResponseChanged = () => ({
	type: ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS PROOF END *********************** */

/** ***************** DELETE BUSINESS PROOF START *********************** */
export const deleteBusinessProofStart = (fetchData: any) => ({
	type: ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_START,
	payload: fetchData,
});

export const deleteBusinessProofSuccess = (successData: any) => ({
	type: ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_SUCCESS,
	payload: successData,
});

export const deleteBusinessProofFailure = (failureData: any) => ({
	type: ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_FAILURE,
	payload: failureData,
});

export const deleteBusinessProofResponseResetStart = () => ({
	type: ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_RESPONSE_RESET,
});

export const deleteBusinessProofResponseChanged = () => ({
	type: ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_RESPONSE_CHANGED,
});
/** ***************** DELETE BUSINESS PROOF END *********************** */
